export default {
    props: {
        titleText: {
            type: String,
            default: undefined,
            kComposite: 'title.text'
        }, 
        titleEncoded: {
            type: Boolean,
            default: undefined,
            kComposite: 'title.encoded'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-window-vue-wrapper/src/KendoWindow/Title.js